// extracted by mini-css-extract-plugin
module.exports = {"pagination":"admin-portal__Pagination__pagination","currentPage":"admin-portal__Pagination__currentPage","spinner":"admin-portal__Pagination__spinner"};